export const PrivacyPolicyLinkPrefixPattern = new RegExp('^(https?:\\/\\/)')
